import $ from 'jquery';
export default [
	'$compile',
	function ($compile) {
		return {
			restrict: 'A',
			link: function (scope, elem, attr) {
				$(function () {
					if (!$('#' + attr.id + ' .captcha-field').length) {
						/* eslint-disable new-cap */
						INBcaptcha_builder(attr.formname, attr.id)
							.withCaptchaIdField(attr.id + '-myCaptchaIdFieldName')
							.withCaptchaResponseField(attr.id + '-myCaptchaValueFieldName')
							.create();
						$('#' + attr.id + ' .info-box').remove();
						$('#' + attr.id + ' .captcha-field')
							.attr('required', 'required')
							.attr('data-ng-model', "data[currentStep]['" + attr.id + "'].value")
							.attr('data-ng-change', "bindCaptchaId('" + attr.id + "')")
							.attr('data-ng-class', "{'input--error':" + attr.formname + "['" + attr.id + "-captcha-text'].$invalid && " + attr.formname + '.$submitted}')
							.removeAttr('placeholder')
							.attr('name', attr.id + '-captcha-text');
						$compile(elem)(scope);
					}
				});
			}
		};
	}
];
